import React from 'react';
import { Show, ReferenceManyField, Datagrid, EditButton, ReferenceField, TextField, useRefresh, usePermissions, DeleteButton, SimpleShowLayout, RichTextField, Pagination } from 'react-admin';
import CardActions from '@material-ui/core/CardActions';
import BackButton from '../components/BackButton';
import ShowFormattedDate from '../components/ShowFormattedDate';
import CustomDateField from '../components/CustomDateField';
import InspectionAdd from '../inspections/InspectionAdd';
import CustomTextField from '../components/CustomTextField';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';
import CustomInspectedFrequenciesField from '../components/CustomInspectedFrequenciesField';
import SystemsIcon from '@material-ui/icons/Tune';
import InspectionsIcon from '@material-ui/icons/FindReplace';
import ISConfig from '../config';
import LastInspectionIcon from '@material-ui/icons/AssignmentTurnedIn';
import NextDeadlineIcon from '@material-ui/icons/NextWeek';

const SystemShowActions = (props) => {
    const { basePath } = props;
    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <EditButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const SystemShowGeneral = ({ record }) => {
    const { name, status, code, type } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row row-cols-3 row-cols-lg-3 g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Code </h6>
                        {code ? code.length > 0 ? <span className="fw-italic m-0 p-0">{code}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name </h6>
                        {name ? name.length > 0 ? <span className="fw-italic m-0 p-0">{name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Status</h6>
                        {status ? status.length > 0 ? <span className="fw-italic m-0 p-0">{status}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Type</h6>
                        {type ? type.length > 0 ? <span className="fw-italic">{type}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Location</h6>
                        <ReferenceField style={{ margin: '0px' }} label="" source="location_id" resource="locations" reference="locations" link="show"><CustomTextField className="m-0 p-0" source="name" /></ReferenceField>
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 mb-3 m-o p-0">
                <SystemShowNotes record={record} />
            </div>
        </div>
    );
};

const SystemShowNotes = ({ record }) => {
    const { notes } = record;

    return (
        <div className="row h-100 w-100 m-0 p-0">
            <div>
                <h6 className="text-secondary" style={{ marginBottom: '10px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes</h6>
                <div className="p-2 pb-0 w-100 h-100" style={{ backgroundColor: 'rgb(255, 238, 201)', borderRadius: '0px 5px 5px 5px' }}>
                    {notes ? notes.length > 0 ? <RichTextField source="notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
};

const SystemShowElements = ({ record }) => {
    const { elements } = record;

    var elementskey = [];
    for (const key in elements) {
        var elementskeycontent = [];
        var inspections = elements[key].inspections;
        for (const keyins in inspections) {
            elementskeycontent.push(
                <li id={keyins.charAt(0) + keyins.slice(1).replace('_', '') + '-li'} className="list-group-item">
                    <div className="row">
                        <div className="col d-flex align-items-center">
                            <h6 className="fw-light text-secondary">{ISConfig.frequencies[keyins].label}</h6>
                        </div>
                        <div className="col">
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Last Inspection</h6>
                            {inspections[keyins].last_inspection ? <ShowFormattedDate date={inspections[keyins].last_inspection} /> : CustomDefaultShowComponent}
                        </div>
                        <div className="col">
                            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Valid Until</h6>
                            {inspections[keyins].valid_until ? <ShowFormattedDate date={inspections[keyins].valid_until} /> : CustomDefaultShowComponent}
                        </div>
                    </div>
                </li>
            )
        }

        var elementskeycontentordered = [];
        ISConfig.frequencies_order.forEach(element => { elementskeycontentordered.push(elementskeycontent.filter(e => e.props.id == element + '-li')[0]) });
        elementskey.push(<ul className="list-group my-3" id={key.charAt(0) + key.slice(1).replace('_', '') + '-ul'}>
            <li class="list-group-item active text-dark fw-bold" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">{key.charAt(0).toUpperCase() + key.slice(1).replace('_', ' ')}</li>
            {elementskeycontentordered}
        </ul>
        );
    }

    return (
        <div>
            <div className="mt-0">
                {elementskey.filter(element => element.props.id == 'main-ul')[0]}
                {elementskey.filter(element => element.props.id == 'antifreeze-ul')[0]}
                {elementskey.filter(element => element.props.id == 'firepump-ul')[0]}
                {elementskey.filter(element => element.props.id == 'trip-ul')[0]}
            </div>
        </div>
    );
};

const SystemShowLastNextInspection = ({ record }) => {
    const { last_inspection, next_deadline } = record;

    const date_last_inspection = new Date(last_inspection);
    const date_next_deadline = new Date(next_deadline);
    const date_actual = new Date();
    const diff_last_inspection = Math.ceil(Math.abs(date_actual - date_last_inspection) / (1000 * 60 * 60 * 24));
    const diff_next_deadline = Math.ceil(Math.abs(date_next_deadline - date_actual) / (1000 * 60 * 60 * 24));

    return (
        <div className="row my-3 m-0 p-0 w-100">
            <ul className="list-group col">
                <li class="list-group-item active text-dark fw-bold d-flex justify-content-between" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">
                    <LastInspectionIcon className="text-success" />
                    <span>Last Inspection</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                    <span className="fst-italic text-muted">{diff_last_inspection > 1? diff_last_inspection +' days ago' : diff_last_inspection +' day ago'}</span>
                    <span style={{ fontSize: '20px' }}>{last_inspection ? <ShowFormattedDate date={last_inspection} /> : CustomDefaultShowComponent}</span>
                </li>
            </ul>
            <ul className="list-group col p-0">
                <li class="list-group-item active text-dark fw-bold d-flex justify-content-between" style={{ border: 'none', backgroundColor: 'rgb(242, 242, 242)' }} aria-current="true">
                    <span>Next Deadline</span>
                    <NextDeadlineIcon className="text-muted" />
                </li>
                <li className="list-group-item d-flex justify-content-between">
                    <span style={{ fontSize: '20px' }}>{next_deadline ? <ShowFormattedDate date={next_deadline} /> : CustomDefaultShowComponent}</span>
                    <span className="fst-italic text-muted">{diff_next_deadline > 1? 'In '+ diff_next_deadline +' days' : 'In '+ diff_next_deadline +' day'}</span>
                </li>
            </ul>
        </div>
    )
}

const InspectionSectionTitle = ({ record }) => {
    return (
        <div className="d-flex align-items-center" >
            <h5 className="font-weight-normal pt-2">{<InspectionsIcon className="d-inline text-danger" style={{ fontSize: '38px' }} />} Inspections </h5>
            <InspectionAdd className="d-inline-block" record={record} onChange={useRefresh()} />
        </div>
    )
}

const SystemShow = (props) => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    let inspectionDeleteButton = null;
    if (isAdmin) { inspectionDeleteButton = ( <DeleteButton redirect={toRedirect} /> ) }

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Systems</h3>
            <Show title=" " actions={<SystemShowActions />} {...props}>
                <SimpleShowLayout>
                    <SystemShowGeneral className="mb-3" record={{ ...props }} />
                    <h6 className="font-weight-normal pt-2">{<SystemsIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Systems</h6>
                    <SystemShowLastNextInspection record={{ ...props }} />
                    <SystemShowElements className="mb-3 mt-0 pt-0" record={{ ...props }} />
                    <InspectionSectionTitle record={{ ...props }} />
                    <ReferenceManyField
                        addLabel={false}
                        reference="inspections"
                        target="system_id"
                        source="id"
                        sort={{ field: 'date', order: 'DESC' }}
                        display="flex" flex="0 0 100%" flexWrap="wrap"
                        pagination={<Pagination />}
                        perPage={10}
                        emptyText="Nothing to show"
                    >
                        <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                            <CustomDateField source="date" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Date </h6>} />
                            <ReferenceField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspector </h6>} source="inspector_id" resource="inspectors" reference="inspectors" link="show">
                                <TextField source="display_name" />
                            </ReferenceField>
                            <CustomInspectedFrequenciesField label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Inspected </h6>} source="inspected" />
                            {inspectionDeleteButton}
                        </Datagrid>
                    </ReferenceManyField>
                </SimpleShowLayout>
            </Show>
        </>
    );
}

export default SystemShow;